import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { authController, processSessionError } from "../../application/auth";

interface SessionHandlerProps {
  children: React.ReactNode;
}

const SessionHandler: React.FC<SessionHandlerProps> = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();

  try {
    React.useEffect(() => {
      let cancel = false;

      authController.refreshSession(cancel);

      return () => {
        cancel = true;
      };
    }, []);

    return <>{children}</>;
  } catch (error) {
    console.error(error);

    if (error instanceof Error) {
      const { cause } = error as processSessionError;

      if (cause?.redirect) {
        useEffect(() => {
          if (cause?.redirect && location.pathname !== cause.redirect) {
            navigate(cause.redirect);
          }
        });

        return <>{children}</>;
      }
    }

    return <>{children}</>;
  }
};

export default SessionHandler;
